export const socialFormActionsStyle = {
	form: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		rowGap: '8px',
		margin: '0 0 24px',
		width: '100%',
		fontSize: '16px',
		lineHeight: '20px',
	},

	divider: {
		marginBottom: '24px',

		'&::before': {
			borderTop: ' 1px solid var(--neutral-100)',
		},

		'&::after': {
			borderTop: ' 1px solid var(--neutral-100)',
		},
	},
};
